import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=480bcff7&"
import script from "./TicketView.vue?vue&type=script&lang=js&"
export * from "./TicketView.vue?vue&type=script&lang=js&"
import style0 from "./TicketView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports